import { useOktaAuth } from '@okta/okta-react';
import { isAnalyticsInitialized } from '@wmgone/analytics/src/analytics-base';
import { useEffect } from 'react';

import { initializeExperimentClient } from './experimentClient';

/**
 * Component used in the Container to initialize the Experiment Client.
 * This component is responsible for fetching the experiment data
 * once the user is authenticated and the analytics module is initialized.
 */
export function Experiments() {
  const { authState } = useOktaAuth();

  useEffect(() => {
    if (isAnalyticsInitialized()) {
      const client = initializeExperimentClient();

      client.fetch();
    }
  }, [authState?.isAuthenticated]);

  return null;
}

Experiments.displayName = 'Experiments';
